export default __webpack_public_path__ + "static/media/chair.74e08e9f.svg";